import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import { initNativeShell, isNativeApp } from "./lib/native";

// The iOS shell updates via OTA bundles (src/lib/ota.ts), not the service worker.
if (isNativeApp) {
  initNativeShell();
} else {
  registerSW({ immediate: true });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
